import { NUMBER } from "../../constants/app-constants";

export const requestIdleCallbackPolyfill = (callback, options = {}) => {
    if (typeof window.requestIdleCallback === "function") {
        return window.requestIdleCallback(callback, options);
    }

    const start = Date.now();
    const timeout = options.timeout || NUMBER.FIFTY;

    const timerId = window.setTimeout(() => {
        const elapsed = Date.now() - start;

        callback({
            didTimeout: elapsed >= timeout,
            timeRemaining: () => Math.max(0, NUMBER.FIFTY - elapsed)
        });
    }, Math.min(timeout, 1)); // Fallback timeout to trigger soon

    return timerId;
};

export const cancelIdleCallbackPolyfill = (id) => {
    if (typeof window.cancelIdleCallback === "function") {
        return window.cancelIdleCallback(id);
    }

    return window.clearTimeout(id);
};
